import { Button, ButtonProps, CircularProgress } from "@material-ui/core";
import React, { ReactNode } from "react";

interface Props extends ButtonProps {
	children?: ReactNode;
	isLoading: boolean;
}

export const ButtonWithLoading = ({ children, isLoading, ...props }: Props) => {
	return (
		<Button {...props} disabled={isLoading}>
			{isLoading && <CircularProgress size={"1rem"} />}
			{children}
		</Button>
	);
};
